import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import axios from 'axios';

const COLORS = { 'Abierta':'#f59e0b', 'En Proceso':'#3b82f6', 'Resuelta':'#10b981' };
const fmtFecha = f => { if (!f) return '—'; const d = f.split('T')[0].split('-'); return `${parseInt(d[2])}-${parseInt(d[1])}-${d[0]}`; };
const fechaParaInput = f => { if (!f) return ''; return f.split('T')[0]; };

const PRINT_STYLES = `
  @media print {
    @page { size: A4; margin: 1.2cm; }
    html, body {
      background: white !important;
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      height: auto !important;
      overflow: visible !important;
      font-size: 16px !important;
    }
    body > * { display: none !important; }
    body > #print-portal { display: block !important; }
    #print-portal {
      position: static !important;
      width: 100% !important;
      max-width: 100% !important;
      margin: 0 !important;
      padding: 0 !important;
      background: white !important;
    }
    #print-portal * { visibility: visible !important; }
    .no-print { display: none !important; }
    .print-only { display: block !important; }
    .print-header {
      display: flex !important;
      justify-content: space-between !important;
      align-items: flex-start !important;
      width: 100% !important;
      padding-bottom: 10px !important;
      margin: 0 0 16px 0 !important;
      border-bottom: 3px solid #5c3d2e !important;
    }
    .print-firmas {
      display: flex !important;
      justify-content: space-around !important;
      gap: 40px !important;
      width: 100% !important;
      margin-top: 40px !important;
      padding-top: 20px !important;
    }
    .fotos-grid-print {
      display: grid !important;
      grid-template-columns: repeat(2, 1fr) !important;
      gap: 12px !important;
      margin-bottom: 8px !important;
    }
    .fotos-grid-print > div { width: 100% !important; }
    .fotos-grid-print img {
      width: 100% !important;
      height: 220px !important;
      object-fit: contain !important;
      border: 1px solid #ccc !important;
      display: block !important;
    }
    .bloque-compacto { padding: 12px 16px !important; margin-bottom: 12px !important; }
    .fila-dato { padding: 8px 0 !important; font-size: 16px !important; }
    * { line-height: 1.4 !important; }
  }
  .print-only { display: none; }
  #print-portal { display: none; }
  @media print {
    #print-portal { display: block !important; }
  }
`;

// ===========================
// MODAL NUEVA / EDITAR GARANTIA MANUAL
// ===========================
function FormGarantiaManual({ onClose, onSaved, modoEditar, datosIniciales, garantiaId }) {
  const [form, setForm] = useState({
    cliente_nombre: datosIniciales?.cliente_nombre || '',
    cedula: datosIniciales?.cedula || '',
    phone1: datosIniciales?.phone1 || '',
    email: datosIniciales?.email || '',
    address: datosIniciales?.address || '',
    article: datosIniciales?.article || '',
    delivery_date: fechaParaInput(datosIniciales?.delivery_date),
    problema: datosIniciales?.problema || ''
  });
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const handleChange = (campo, valor) => setForm(prev => ({ ...prev, [campo]: valor }));

  const handleSubmit = async () => {
    if (!form.cliente_nombre.trim() || !form.article.trim() || !form.delivery_date || !form.problema.trim()) {
      alert('Por favor complete los campos obligatorios: cliente, artículo, fecha de entrega y problema');
      return;
    }
    setLoading(true);
    try {
      let res;
      if (modoEditar) {
        res = await axios.patch(`/api/garantias/${garantiaId}/manual`, form, { headers });
        alert('Garantía actualizada exitosamente');
      } else {
        res = await axios.post('/api/garantias/manual', form, { headers });
        alert(`Garantía creada exitosamente: ${res.data.numero_manual}`);
      }
      if (onSaved) onSaved(res.data.id);
      onClose();
    } catch (err) {
      alert(err.response?.data?.error || 'Error al guardar la garantía');
    }
    setLoading(false);
  };

  const inputStyle = { width:'100%', padding:'9px 12px', border:'1px solid #ddd', borderRadius:7, fontSize:13, boxSizing:'border-box', marginBottom:10, outline:'none' };
  const labelStyle = { display:'block', fontSize:12, color:'#5c3d2e', fontWeight:600, marginBottom:4, marginTop:4 };

  return (
    <div onClick={onClose} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:300 }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:'#fff', borderRadius:12, padding:28, maxWidth:560, width:'90%', maxHeight:'92vh', overflowY:'auto' }}>
        <div style={{ marginBottom:16 }}>
          <div style={{ fontWeight:800, fontSize:18, color:'#5c3d2e' }}>
            {modoEditar ? '✏️ Editar Garantía Manual' : '📝 Nueva Garantía Manual'}
          </div>
          <div style={{ fontSize:12, color:'#888', marginTop:2 }}>
            {modoEditar ? 'Modifique los datos que necesite corregir' : 'Para muebles vendidos antes del sistema'}
          </div>
        </div>

        {!modoEditar && (
          <div style={{ background:'#fff8f0', border:'1px solid #f0d9c0', borderRadius:7, padding:10, fontSize:12, color:'#666', marginBottom:14 }}>
            ℹ️ Use este formulario solo si el mueble NO tiene una orden de venta en el sistema. Si la tiene, abra la garantía desde la orden normalmente.
          </div>
        )}

        <label style={labelStyle}>Nombre del cliente *</label>
        <input style={inputStyle} value={form.cliente_nombre} onChange={e=>handleChange('cliente_nombre', e.target.value)} placeholder="Nombre completo" />

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
          <div>
            <label style={labelStyle}>Cédula (opcional)</label>
            <input style={inputStyle} value={form.cedula} onChange={e=>handleChange('cedula', e.target.value)} placeholder="1-1234-5678" />
          </div>
          <div>
            <label style={labelStyle}>Teléfono (opcional)</label>
            <input style={inputStyle} value={form.phone1} onChange={e=>handleChange('phone1', e.target.value)} placeholder="8888-8888" />
          </div>
        </div>

        <label style={labelStyle}>Correo (opcional)</label>
        <input style={inputStyle} type="email" value={form.email} onChange={e=>handleChange('email', e.target.value)} placeholder="cliente@correo.com" />

        <label style={labelStyle}>Dirección (opcional)</label>
        <input style={inputStyle} value={form.address} onChange={e=>handleChange('address', e.target.value)} placeholder="Provincia, cantón, señas" />

        <label style={labelStyle}>Artículo *</label>
        <input style={inputStyle} value={form.article} onChange={e=>handleChange('article', e.target.value)} placeholder="Ej: Sofá cama Italia, color negro" />

        <label style={labelStyle}>Fecha de entrega *</label>
        <input style={inputStyle} type="date" value={form.delivery_date} onChange={e=>handleChange('delivery_date', e.target.value)} />

        <label style={labelStyle}>Problema reportado *</label>
        <textarea
          value={form.problema}
          onChange={e=>handleChange('problema', e.target.value)}
          placeholder="Describa el problema..."
          style={{ ...inputStyle, minHeight:80, resize:'vertical' }}
        />

        <div style={{ display:'flex', gap:8, marginTop:8 }}>
          <button onClick={handleSubmit} disabled={loading}
            style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'9px 20px', borderRadius:7, cursor:'pointer', fontSize:13, fontWeight:600, opacity:loading?0.7:1 }}>
            {loading ? 'Guardando...' : (modoEditar ? '💾 Guardar cambios' : '✅ Crear Garantía')}
          </button>
          <button onClick={onClose} style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'9px 18px', borderRadius:7, cursor:'pointer', fontSize:13 }}>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
}

function FotosGarantia({ garantiaId, fotos, setFotos }) {
  const [uploading, setUploading] = useState(false);
  const [lightbox, setLightbox] = useState(null);
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('photo', file);
      await axios.post(`/api/garantias/${garantiaId}/fotos`, formData, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' }
      });
      const res = await axios.get(`/api/garantias/${garantiaId}/fotos`, { headers });
      setFotos(res.data);
    } catch { alert('Error al subir la foto'); }
    setUploading(false);
    e.target.value = '';
  };

  const handleDelete = async (fotoId) => {
    if (!window.confirm('¿Eliminar esta foto?')) return;
    try {
      await axios.delete(`/api/garantias/${garantiaId}/fotos/${fotoId}`, { headers });
      setFotos(prev => prev.filter(f => f.id !== fotoId));
    } catch { alert('Error al eliminar'); }
  };

  return (
    <div style={{ marginTop:12 }}>
      <div style={{ fontWeight:700, fontSize:13, color:'#5c3d2e', marginBottom:8 }}>📷 Fotos del problema {fotos.length > 0 ? `(${fotos.length})` : ''}</div>
      {fotos.length === 0 && <div style={{ color:'#aaa', fontSize:13, marginBottom:8 }}>No hay fotos agregadas</div>}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(100px, 1fr))', gap:8, marginBottom:10 }}>
        {fotos.map(foto => (
          <div key={foto.id} style={{ position:'relative' }}>
            <img
              src={`/uploads/garantias/${foto.filename}`}
              alt="Problema"
              onClick={() => setLightbox(`/uploads/garantias/${foto.filename}`)}
              style={{ width:'100%', height:90, objectFit:'cover', borderRadius:6, cursor:'pointer', border:'1px solid #e8ddd4' }}
            />
            <button onClick={() => handleDelete(foto.id)}
              style={{ position:'absolute', top:3, right:3, background:'rgba(239,68,68,0.85)', color:'#fff', border:'none', borderRadius:'50%', width:20, height:20, cursor:'pointer', fontSize:11, padding:0 }}>
              ✕
            </button>
          </div>
        ))}
      </div>
      <label style={{ display:'inline-block', background: uploading ? '#aaa' : '#5c3d2e', color:'#fff', padding:'6px 14px', borderRadius:7, cursor: uploading ? 'not-allowed' : 'pointer', fontSize:12, fontWeight:600 }}>
        {uploading ? '⏳ Subiendo...' : '📷 Agregar foto'}
        <input type="file" accept="image/*" style={{ display:'none' }} onChange={handleUpload} disabled={uploading}/>
      </label>
      {lightbox && (
        <div onClick={() => setLightbox(null)} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.85)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:500, cursor:'pointer' }}>
          <img src={lightbox} alt="Foto" style={{ maxWidth:'90%', maxHeight:'90vh', borderRadius:8 }}/>
        </div>
      )}
    </div>
  );
}

function ContenidoImprimible({ g, fotos }) {
  const diasDesdeEntrega = g.delivery_date ? Math.floor((new Date() - new Date(g.delivery_date)) / (1000*60*60*24)) : null;
  const enGarantia = diasDesdeEntrega !== null && diasDesdeEntrega <= 365;
  return (
    <div style={{ padding: 0, fontFamily: "'Segoe UI', sans-serif", color: '#333' }}>
      <div className="print-header">
        <div>
          <div style={{ fontSize:28, fontWeight:800, color:'#5c3d2e', letterSpacing:1 }}>MUEBLES TERRASOL</div>
          <div style={{ fontSize:16, color:'#888', marginTop:4 }}>Reporte de Garantía{g.es_manual ? ' (Manual)' : ''}</div>
        </div>
        <div style={{ textAlign:'right' }}>
          <div style={{ fontSize:20, fontWeight:700, color:'#5c3d2e' }}>GARANTÍA #{g.id}</div>
          <div style={{ fontSize:18, color:'#a0522d', fontWeight:700 }}>{g.numero}</div>
          <div style={{ fontSize:13, color:'#888', marginTop:2 }}>Impreso: {new Date().toLocaleDateString('es-CR')}</div>
          <div style={{ marginTop:6, display:'inline-block', background:COLORS[g.status]||'#aaa', color:'#fff', padding:'4px 14px', borderRadius:20, fontSize:14, fontWeight:600 }}>{g.status}</div>
        </div>
      </div>

      <div className="bloque-compacto" style={{ background: enGarantia ? '#f0fdf4' : '#fef2f2', border:`1px solid ${enGarantia ? '#bbf7d0' : '#fecaca'}`, borderRadius:6 }}>
        <strong style={{ color: enGarantia ? '#166534' : '#991b1b', fontSize:17 }}>
          {enGarantia ? '✅ Dentro de garantía' : '⚠️ Fuera de garantía'}
        </strong>
        <span style={{ color:'#666', marginLeft:10, fontSize:15 }}>{diasDesdeEntrega !== null ? `${diasDesdeEntrega} días desde la entrega` : ''}</span>
      </div>

      <div style={{ marginBottom:14 }}>
        {[
          ['Cliente', g.cliente_nombre],
          ['Cédula', g.cedula || '—'],
          ['Teléfono', g.phone1 || '—'],
          ['Correo', g.email || '—'],
          ['Dirección', g.address || '—'],
          ['Artículo', g.article],
          ['Fecha Entrega', fmtFecha(g.delivery_date)],
          ['Abierta por', g.abierta_por_nombre],
          ['Fecha apertura', fmtFecha(g.created_at)],
        ].map(([l,v]) => (
          <div key={l} className="fila-dato" style={{ display:'flex', justifyContent:'space-between', borderBottom:'1px solid #f0e8e0' }}>
            <span style={{ color:'#888', fontWeight:600 }}>{l}</span>
            <span style={{ fontWeight:600, textAlign:'right' }}>{v}</span>
          </div>
        ))}
      </div>

      <div className="bloque-compacto" style={{ background:'#fff8f0', border:'1px solid #f0d9c0', borderRadius:6, fontSize:16 }}>
        <strong>📝 Problema reportado:</strong> {g.problema}
      </div>

      {fotos && fotos.length > 0 && (
        <div className="bloque-compacto" style={{ border:'1px solid #e8ddd4', borderRadius:6 }}>
          <div style={{ fontWeight:700, fontSize:16, color:'#5c3d2e', marginBottom:10 }}>📷 Fotos del problema ({fotos.length})</div>
          <div className="fotos-grid-print">
            {fotos.map(foto => (
              <div key={foto.id}>
                <img src={`/uploads/garantias/${foto.filename}`} alt="Problema"/>
              </div>
            ))}
          </div>
        </div>
      )}

      {g.seguimientos && g.seguimientos.length > 0 && (
        <div style={{ marginTop:14 }}>
          <div style={{ fontSize:17, fontWeight:700, color:'#5c3d2e', marginBottom:8 }}>📋 Historial de seguimiento</div>
          {g.seguimientos.map((s, i) => (
            <div key={i} className="bloque-compacto" style={{ background:'#f8f5f0', borderRadius:6 }}>
              <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                <span style={{ fontWeight:600, fontSize:15, color:'#5c3d2e' }}>{s.usuario_nombre}</span>
                <span style={{ fontSize:14, color:'#aaa' }}>{fmtFecha(s.created_at)}</span>
              </div>
              <div style={{ fontSize:16 }}>{s.nota}</div>
            </div>
          ))}
        </div>
      )}

      <div className="print-firmas">
        <div style={{ textAlign:'center', flex:1, maxWidth:260 }}>
          <div style={{ borderTop:'1px solid #5c3d2e', paddingTop:6, fontSize:15, color:'#5c3d2e', fontWeight:600 }}>Firma Cliente</div>
        </div>
        <div style={{ textAlign:'center', flex:1, maxWidth:260 }}>
          <div style={{ borderTop:'1px solid #5c3d2e', paddingTop:6, fontSize:15, color:'#5c3d2e', fontWeight:600 }}>Firma Responsable</div>
        </div>
      </div>
    </div>
  );
}

function GarantiaDetalle({ garantiaId, onClose, onUpdated }) {
  const { user } = useAuth();
  const [g, setG] = useState(null);
  const [fotos, setFotos] = useState([]);
  const [nota, setNota] = useState('');
  const [loading, setLoading] = useState(false);
  const [showEditar, setShowEditar] = useState(false);
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { cargar(); cargarFotos(); }, [garantiaId]);

  const cargar = async () => {
    try {
      const res = await axios.get(`/api/garantias/${garantiaId}`, { headers });
      setG(res.data);
    } catch {}
  };

  const cargarFotos = async () => {
    try {
      const res = await axios.get(`/api/garantias/${garantiaId}/fotos`, { headers });
      setFotos(res.data);
    } catch {}
  };

  const cambiarEstado = async (status) => {
    try {
      await axios.patch(`/api/garantias/${garantiaId}/status`, { status }, { headers });
      await cargar();
      if (onUpdated) onUpdated();
    } catch { alert('Error al cambiar estado'); }
  };

  const agregarNota = async () => {
    if (!nota.trim()) return;
    setLoading(true);
    try {
      await axios.post(`/api/garantias/${garantiaId}/seguimiento`, { nota }, { headers });
      setNota('');
      await cargar();
    } catch { alert('Error al agregar nota'); }
    setLoading(false);
  };

  const handlePrint = () => {
    let portal = document.getElementById('print-portal');
    if (!portal) {
      portal = document.createElement('div');
      portal.id = 'print-portal';
      document.body.appendChild(portal);
    }
    import('react-dom/client').then(({ createRoot }) => {
      const root = createRoot(portal);
      root.render(<ContenidoImprimible g={g} fotos={fotos} />);
      setTimeout(() => {
        window.print();
        setTimeout(() => {
          root.unmount();
          if (portal.parentNode) portal.parentNode.removeChild(portal);
        }, 500);
      }, 300);
    });
  };

  if (!g) return <div style={{ padding:40, textAlign:'center', color:'#888' }}>Cargando...</div>;

  const diasDesdeEntrega = g.delivery_date ? Math.floor((new Date() - new Date(g.delivery_date)) / (1000*60*60*24)) : null;
  const enGarantia = diasDesdeEntrega !== null && diasDesdeEntrega <= 365;
  const puedeEditar = g.es_manual && (user.role === 'admin' || user.username === 'fperez');

  const s = {
    overlay: { position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:200 },
    box: { background:'#fff', borderRadius:12, padding:28, maxWidth:660, width:'90%', maxHeight:'92vh', overflowY:'auto' },
    row: { display:'flex', justifyContent:'space-between', padding:'7px 0', borderBottom:'1px solid #f0e8e0', fontSize:13 },
    badge: s => ({ background:COLORS[s]||'#aaa', color:'#fff', padding:'3px 12px', borderRadius:20, fontSize:11, fontWeight:600 }),
  };

  return (
    <>
      <style>{PRINT_STYLES}</style>
      <div className="no-print" style={s.overlay} onClick={onClose}>
        <div style={s.box} onClick={e=>e.stopPropagation()}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16, flexWrap:'wrap', gap:8 }}>
            <div>
              <div style={{ fontWeight:800, fontSize:18, color:'#5c3d2e' }}>
                Garantía #{g.id} {g.es_manual && <span style={{ fontSize:11, background:'#a0522d', color:'#fff', padding:'2px 8px', borderRadius:10, marginLeft:6, verticalAlign:'middle' }}>MANUAL</span>}
              </div>
              <div style={{ fontSize:12, color:'#aaa' }}>Orden: {g.numero}</div>
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:8 }}>
              {puedeEditar && (
                <button onClick={()=>setShowEditar(true)}
                  style={{ background:'#f0ebe5', color:'#5c3d2e', border:'1px solid #d4c4b0', padding:'5px 12px', borderRadius:7, cursor:'pointer', fontSize:12, fontWeight:600 }}>
                  ✏️ Editar
                </button>
              )}
              <span style={s.badge(g.status)}>{g.status}</span>
            </div>
          </div>

          <div style={{ background: enGarantia ? '#f0fdf4' : '#fef2f2', border:`1px solid ${enGarantia ? '#bbf7d0' : '#fecaca'}`, borderRadius:8, padding:'10px 14px', marginBottom:14, fontSize:13 }}>
            <strong style={{ color: enGarantia ? '#166534' : '#991b1b' }}>
              {enGarantia ? '✅ Dentro de garantía' : '⚠️ Fuera de garantía'}
            </strong>
            <span style={{ color:'#666', marginLeft:8 }}>{diasDesdeEntrega !== null ? `${diasDesdeEntrega} días desde la entrega` : ''}</span>
          </div>

          <div style={{ marginBottom:14 }}>
            {[
              ['Cliente', g.cliente_nombre],
              ['Cédula', g.cedula || '—'],
              ['Teléfono', g.phone1 || '—'],
              ['Correo', g.email || '—'],
              ['Dirección', g.address || '—'],
              ['Artículo', g.article],
              ['Fecha Entrega', fmtFecha(g.delivery_date)],
              ['Abierta por', g.abierta_por_nombre],
              ['Fecha apertura', fmtFecha(g.created_at)],
            ].map(([l,v]) => (
              <div key={l} style={s.row}><span style={{ color:'#888', fontWeight:600 }}>{l}</span><span style={{ fontWeight:600, textAlign:'right' }}>{v}</span></div>
            ))}
          </div>

          <div style={{ background:'#fff8f0', border:'1px solid #f0d9c0', borderRadius:8, padding:12, fontSize:13, marginBottom:14 }}>
            <strong>📝 Problema reportado:</strong> {g.problema}
          </div>

          <div style={{ background:'#f8f5f0', border:'1px solid #e8ddd4', borderRadius:8, padding:14, marginBottom:14 }}>
            <FotosGarantia garantiaId={garantiaId} fotos={fotos} setFotos={setFotos} />
          </div>

          {(user.role === 'admin' || user.username === 'fperez') && g.status !== 'Resuelta' && (
            <div style={{ marginBottom:14 }}>
              <div style={{ fontSize:12, color:'#888', marginBottom:6, fontWeight:600 }}>CAMBIAR ESTADO:</div>
              <div style={{ display:'flex', gap:6 }}>
                {['Abierta','En Proceso','Resuelta'].map(st => (
                  <button key={st} onClick={() => cambiarEstado(st)}
                    style={{ background: g.status === st ? COLORS[st] : '#f0ebe5', color: g.status === st ? '#fff' : '#5c3d2e', border:'none', padding:'6px 14px', borderRadius:6, cursor:'pointer', fontSize:12, fontWeight:600 }}>
                    {st}
                  </button>
                ))}
              </div>
            </div>
          )}

          <div style={{ marginBottom:14 }}>
            <div style={{ fontSize:13, fontWeight:700, color:'#5c3d2e', marginBottom:8 }}>📋 Historial de seguimiento</div>
            {g.seguimientos.length === 0 && <div style={{ color:'#aaa', fontSize:13 }}>Sin notas aún</div>}
            {g.seguimientos.map((s, i) => (
              <div key={i} style={{ background:'#f8f5f0', borderRadius:8, padding:'10px 12px', marginBottom:8 }}>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                  <span style={{ fontWeight:600, fontSize:12, color:'#5c3d2e' }}>{s.usuario_nombre}</span>
                  <span style={{ fontSize:11, color:'#aaa' }}>{fmtFecha(s.created_at)}</span>
                </div>
                <div style={{ fontSize:13 }}>{s.nota}</div>
              </div>
            ))}
          </div>

          {g.status !== 'Resuelta' && (
            <div>
              <textarea value={nota} onChange={e=>setNota(e.target.value)} placeholder="Agregar nota de seguimiento..."
                style={{ width:'100%', padding:'9px 12px', border:'1px solid #ddd', borderRadius:7, fontSize:13, boxSizing:'border-box', resize:'vertical', minHeight:70, marginBottom:8 }}
              />
              <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                <button onClick={agregarNota} disabled={loading}
                  style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'8px 18px', borderRadius:7, cursor:'pointer', fontSize:13, fontWeight:600, opacity:loading?0.7:1 }}>
                  {loading ? 'Guardando...' : '💬 Agregar nota'}
                </button>
                <button onClick={handlePrint}
                  style={{ background:'#a0522d', color:'#fff', border:'none', padding:'8px 18px', borderRadius:7, cursor:'pointer', fontSize:13, fontWeight:600 }}>
                  🖨️ Imprimir
                </button>
                <button onClick={onClose} style={{ background:'#f0ebe5', color:'#5c3d2e', border:'none', padding:'8px 16px', borderRadius:7, cursor:'pointer', fontSize:13 }}>Cerrar</button>
              </div>
            </div>
          )}
          {g.status === 'Resuelta' && (
            <div style={{ display:'flex', gap:8 }}>
              <button onClick={handlePrint}
                style={{ background:'#a0522d', color:'#fff', border:'none', padding:'8px 18px', borderRadius:7, cursor:'pointer', fontSize:13, fontWeight:600 }}>
                🖨️ Imprimir
              </button>
              <button onClick={onClose} style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'8px 18px', borderRadius:7, cursor:'pointer', fontSize:13, fontWeight:600 }}>Cerrar</button>
            </div>
          )}
        </div>
      </div>

      {showEditar && (
        <FormGarantiaManual
          modoEditar={true}
          garantiaId={garantiaId}
          datosIniciales={g}
          onClose={()=>setShowEditar(false)}
          onSaved={()=>{ cargar(); if (onUpdated) onUpdated(); }}
        />
      )}
    </>
  );
}

export default function Garantias() {
  const [garantias, setGarantias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('Todos');
  const [selected, setSelected] = useState(null);
  const [search, setSearch] = useState('');
  const [showNuevaManual, setShowNuevaManual] = useState(false);
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const cargar = async () => {
    try {
      const res = await axios.get('/api/garantias', { headers });
      setGarantias(res.data);
    } catch {}
    setLoading(false);
  };

  useEffect(() => { cargar(); }, []);

  const filtradas = garantias.filter(g => {
    if (filtro !== 'Todos' && g.status !== filtro) return false;
    if (search) {
      const s = search.toLowerCase();
      return [g.numero, g.cliente_nombre, g.article, g.problema].some(v => v?.toLowerCase().includes(s));
    }
    return true;
  });

  const s = {
    page: { fontFamily:"'Segoe UI',sans-serif", minHeight:'100vh', background:'#f8f5f0' },
    main: { maxWidth:1100, margin:'0 auto', padding:'20px 14px' },
    card: { background:'#fff', borderRadius:10, boxShadow:'0 1px 6px rgba(0,0,0,0.09)', padding:22, marginBottom:18 },
    badge: st => ({ background:COLORS[st]||'#aaa', color:'#fff', padding:'2px 10px', borderRadius:20, fontSize:11, fontWeight:600, display:'inline-block' }),
    btn: active => ({ background:active?'#5c3d2e':'#f0ebe5', color:active?'#fff':'#5c3d2e', border:'none', padding:'6px 14px', borderRadius:7, cursor:'pointer', fontSize:12, marginRight:4 }),
    th: { background:'#f5ede6', padding:'9px 11px', textAlign:'left', fontWeight:600, color:'#5c3d2e', borderBottom:'2px solid #e0d0c0', fontSize:13 },
    td: { padding:'9px 11px', borderBottom:'1px solid #f0e8e0', fontSize:13, verticalAlign:'middle' },
  };

  const conteos = {
    Todos: garantias.length,
    Abierta: garantias.filter(g=>g.status==='Abierta').length,
    'En Proceso': garantias.filter(g=>g.status==='En Proceso').length,
    Resuelta: garantias.filter(g=>g.status==='Resuelta').length,
  };

  return (
    <div className="no-print" style={s.page}>
      <Navbar />
      <div style={s.main}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:18, flexWrap:'wrap', gap:10 }}>
          <h1 style={{ margin:0, color:'#5c3d2e', fontSize:22 }}>🛡️ Garantías</h1>
          <div style={{ display:'flex', alignItems:'center', gap:14 }}>
            <div style={{ fontSize:13, color:'#888' }}>{garantias.length} casos en total</div>
            <button onClick={()=>setShowNuevaManual(true)}
              style={{ background:'#a0522d', color:'#fff', border:'none', padding:'8px 16px', borderRadius:7, cursor:'pointer', fontSize:13, fontWeight:600 }}>
              ➕ Nueva Garantía Manual
            </button>
          </div>
        </div>

        <div style={s.card}>
          <input value={search} onChange={e=>setSearch(e.target.value)}
            placeholder="🔍 Buscar por cliente, orden o artículo..."
            style={{ width:'100%', padding:'10px 14px', border:'1px solid #ddd', borderRadius:8, fontSize:14, boxSizing:'border-box', marginBottom:14, outline:'none' }}
          />
          <div style={{ display:'flex', gap:4, flexWrap:'wrap' }}>
            {['Todos','Abierta','En Proceso','Resuelta'].map(f => (
              <button key={f} onClick={()=>setFiltro(f)} style={s.btn(filtro===f)}>
                {f} ({conteos[f]})
              </button>
            ))}
          </div>
        </div>

        <div style={s.card}>
          {loading && <div style={{ textAlign:'center', padding:30, color:'#aaa' }}>Cargando...</div>}
          {!loading && filtradas.length === 0 && (
            <div style={{ textAlign:'center', padding:30, color:'#aaa' }}>No hay garantías {filtro !== 'Todos' ? `en estado "${filtro}"` : ''}</div>
          )}
          {!loading && filtradas.length > 0 && (
            <div style={{ overflowX:'auto' }}>
              <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13 }}>
                <thead>
                  <tr>
                    <th style={s.th}>#</th>
                    <th style={s.th}>Orden</th>
                    <th style={s.th}>Cliente</th>
                    <th style={s.th}>Artículo</th>
                    <th style={s.th}>Problema</th>
                    <th style={s.th}>F. Apertura</th>
                    <th style={s.th}>Estado</th>
                    <th style={s.th}>Acción</th>
                  </tr>
                </thead>
                <tbody>
                  {filtradas.map(g => (
                    <tr key={g.id} style={{ cursor:'pointer' }} onClick={()=>setSelected(g.id)}>
                      <td style={s.td}>{g.id}</td>
                      <td style={{ ...s.td, fontWeight:600, color:'#a0522d' }}>
                        {g.numero}
                        {g.es_manual && <span title="Garantía manual (sin orden de venta)" style={{ marginLeft:5, fontSize:11 }}>📝</span>}
                      </td>
                      <td style={s.td}><strong>{g.cliente_nombre}</strong><div style={{ fontSize:11, color:'#aaa' }}>{g.phone1 || ''}</div></td>
                      <td style={s.td}>{g.article}</td>
                      <td style={s.td}><div style={{ maxWidth:200, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{g.problema}</div></td>
                      <td style={s.td}>{fmtFecha(g.created_at)}</td>
                      <td style={s.td}><span style={s.badge(g.status)}>{g.status}</span></td>
                      <td style={s.td} onClick={e=>e.stopPropagation()}>
                        <button onClick={()=>setSelected(g.id)} style={{ background:'#5c3d2e', color:'#fff', border:'none', padding:'5px 12px', borderRadius:6, cursor:'pointer', fontSize:12 }}>
                          Ver
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {selected && (
        <GarantiaDetalle garantiaId={selected} onClose={()=>setSelected(null)} onUpdated={cargar} />
      )}

      {showNuevaManual && (
        <FormGarantiaManual
          onClose={()=>setShowNuevaManual(false)}
          onSaved={(nuevaId)=>{cargar(); if(nuevaId) setSelected(nuevaId);}}
        />
      )}
    </div>
  );
}
